import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { MassiveLoadResult } from './../model/massive-load-result';

const API_PATH = '/Masivas/{idPlantilla}';

@Injectable()
export class CargaMasivaService {

  constructor(
    private http: HttpClient
  ) { }

  getEmptyTemplateFile(templateId: number): Observable<Blob> {
    return this.http.get(environment.API_BASE + API_PATH.replace('{idPlantilla}', '' + templateId), { responseType: 'blob' });
  }

  validateFile(templateId: number, fileData: any): Observable<MassiveLoadResult> {
    const formData = new FormData();
    formData.append('file', fileData);
    return this.http.post<MassiveLoadResult>(environment.API_BASE + API_PATH.replace('{idPlantilla}', '' + templateId), formData)
      .pipe(map((result: any) => MassiveLoadResult.toModel(JSON.stringify(result))));
  }

}
